import React, { FC } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { useIntl } from 'react-intl';

import { PromotionType } from 'generated/graphql-gateway';
import { IIncentiveEvaluationResult } from 'state/loyalty/hooks/types';
import { getEvaluationResultMessage } from 'state/loyalty/hooks/utils/helpers';

import {
  IconWrapper,
  IncentiveEvaluationMessagesWrapper,
  SingleMessage,
} from './incentive-evaluation-messages.styled';

interface IIncentiveEvaluationMessageContentProps {
  message?: React.ReactNode;
  hideIcon?: boolean;
}

const IncentiveEvaluationMessageContent = ({
  hideIcon,
  message,
}: IIncentiveEvaluationMessageContentProps) => {
  return (
    <SingleMessage>
      {!hideIcon && (
        <IconWrapper>
          <Icon icon="error" color="text-error" width="24px" aria-hidden />
        </IconWrapper>
      )}
      <span>{message}</span>
    </SingleMessage>
  );
};

interface IIncentiveEvaluationMessageProps {
  className?: string;
  message?: React.ReactNode;
  hideIcon?: boolean;
}

export const IncentiveEvaluationMessage = ({
  className = '',
  message = '',
  hideIcon = false,
}: IIncentiveEvaluationMessageProps) => {
  return (
    <IncentiveEvaluationMessagesWrapper className={className}>
      <IncentiveEvaluationMessageContent message={message} hideIcon={hideIcon} />
    </IncentiveEvaluationMessagesWrapper>
  );
};

interface IIncentiveEvaluationMessagesProps {
  className?: string;
  incentiveEvaluationResults: IIncentiveEvaluationResult[];
  hideIcon?: boolean;
}

export const IncentiveEvaluationMessages: FC<IIncentiveEvaluationMessagesProps> = ({
  className = '',
  incentiveEvaluationResults = [],
  hideIcon = false,
}) => {
  const formatters = useIntl();

  return (
    <IncentiveEvaluationMessagesWrapper className={className}>
      {incentiveEvaluationResults.map(evaluationResult => {
        const message = getEvaluationResultMessage({
          evaluationResult,
          formatters,
          incentiveType: PromotionType.OFFER,
        });

        return (
          <IncentiveEvaluationMessageContent
            key={evaluationResult.code}
            hideIcon={hideIcon}
            message={message}
          />
        );
      })}
    </IncentiveEvaluationMessagesWrapper>
  );
};
